'use client';

import React__default from 'react';

var AiCheckIcon = function (_a) {
    var style = _a.style;
    return (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", style: style },
        React__default.createElement("path", { d: "M9.00078 2.30078C5.02458 2.30078 1.80078 5.52458 1.80078 9.50078C1.80078 13.477 5.02458 16.7008 9.00078 16.7008C12.977 16.7008 16.2008 13.477 16.2008 9.50078C16.2008 5.52458 12.977 2.30078 9.00078 2.30078ZM13.025 8.12498L8.48898 12.661C8.37618 12.7738 8.22378 12.8368 8.06478 12.8368C7.90578 12.8368 7.75278 12.7738 7.64058 12.661L5.56878 10.5892C5.33418 10.3546 5.33418 9.97538 5.56878 9.74078C5.80338 9.50618 6.18258 9.50618 6.41718 9.74078L8.06478 11.3884L12.1766 7.27658C12.4112 7.04198 12.7904 7.04198 13.025 7.27658C13.2596 7.51118 13.2596 7.89038 13.025 8.12498Z", fill: "#00B70B" })));
};
var AiCheckIcon$1 = React__default.memo(AiCheckIcon);

export { AiCheckIcon$1 as default };
//# sourceMappingURL=AiCheckIcon.js.map
